import React from 'react';
import { Box, Checkbox, Typography, Chip } from '@mui/material';
import PermissionCardActions from './permission_card_actions';
import PermissionCardStatus from './permission_card_status';
import { permissionCardStyles } from '.';

import { getTruncatedModuleNames } from 'utils/permission_utils';

interface PermissionCardProps {
  permission: {
    name: string;
    profile: {
      group: {
        name: string;
        uuid: string;
      };
    };
    permissions: Array<{
      module: {
        name: string;
        uuid: string;
      };
    }>;
    is_active: boolean;
  };
  isChecked: boolean;
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onEdit: () => void;
  onView: () => void;
  onDelete: () => void;
  onToggleStatus: () => void;
}

const PermissionCard: React.FC<PermissionCardProps> = ({
  permission,
  isChecked,
  onCheckboxChange,
  onEdit,
  onView,
  onDelete,
  onToggleStatus,
}) => {
  return (
    <Box sx={permissionCardStyles.container}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Checkbox checked={isChecked} onChange={onCheckboxChange} />
        </Box>

        <Box sx={permissionCardStyles.details}>
          <Typography
            sx={{
              color: '#000000DE',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '28.26px',
              letterSpacing: '0.1px',
            }}
          >
            {permission.name}
          </Typography>

          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
            }}
          >
            {`Grupo: ${permission.profile.group.name ?? ''}`}
          </Typography>

          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
            }}
          >
            {`Permissão: ${getTruncatedModuleNames(permission, 50) ?? ''}`}
          </Typography>
        </Box>

        <PermissionCardActions
          onEdit={onEdit}
          onView={onView}
          onDelete={onDelete}
          onToggleStatus={onToggleStatus}
          isActive={permission.is_active}
        />
      </Box>

      <PermissionCardStatus isActive={permission.is_active} />
    </Box>
  );
};

export default PermissionCard;
